<div class="card-block meetingtab p-0">

  <div class="nav-tabs-horizontal">
    <ul class="nav nav-tabs tab-list" style="border: none" role="tablist" *ngIf="rowFive">
      <li class="nav-item" *ngIf="rowFive">
        <a
          class="nav-link active"
          data-target="#meetingTab"
          data-toggle="tab"
          href="javascript: void(0);"
          role="tab"
          aria-expanded="true"
          (click)="tabSelected('meetingTab')"
          >My Meetings</a
        >
      </li>
      <li class="nav-item" *ngIf="rowFive">
        <a
          class="nav-link"
          data-target="#teamTaskTab"
          data-toggle="tab"
          href="javascript: void(0);"
          role="tab"
          aria-expanded="false"
          (click)="tabSelected('teamTaskTab')"
          >Team Task</a
        >
      </li>
    </ul>
    <div class="tab-content">
      <div
        class="tab-pane active"
        id="meetingTab"
        role="tabcard"
        aria-expanded="true"
      >
        <div
          *ngIf="isMeetingFetch != 'false' && meetingDataPrefetching"
          class="py-4 text-center text-muted"
        >
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          <span class="ml-2">Loading meetings…</span>
        </div>
        <div
          *ngIf="isMeetingFetch != 'false' && showMeetingCalendarMount"
          class="calendar-meeting-host"
        >
          <div class="example-calendar-block" id="meeting"></div>
          <div
            *ngIf="isMeetingFetch != 'false' && meetingCalendarRangeLoading"
            class="calendar-range-loading-overlay text-center text-muted"
            aria-live="polite"
            aria-busy="true"
          >
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            <span class="ml-2">Loading meetings…</span>
          </div>
        </div>
      </div>

      <div class="tab-pane" id="teamTaskTab" role="tabcard" aria-expanded="true">
        <div class="example-calendar-block" id="teamTask"></div>
      </div>
    </div>
  </div>
</div>
